import { listService } from '../../services/ListService';

import Multiselect from 'vue-multiselect';
import { required, minLength } from 'vuelidate/lib/validators';
import { mapGetters, mapMutations } from 'vuex';
import { String, Number } from 'core-js';


export default {
    name: 'EditAddress',

    components: {
        Multiselect
    },

    props: {
        editAddressType: {
            type: Number,
        },
        isEditable: true,
        isOwnerAddress: true,
    },

    data: () => {
        return {
            loading: true,
            //
            address: {},
            //
            county: null,
            counties: [], // Filled on created()
            //
            town: null,
            towns: [], // Filled on created()
        }
    },

    validations: {
        address: {
            County : {
                required
            },
            SIRUTA: {
                required
            },
            Street: {
                required
            },
            No: {
                required
            },
            Bloc: {
                //required
            },
            Staircase: {
               // required
            },
            Floor: {
              //  required
            },
            Apartment: {
              //  required
            }
        },
    },

    computed: {
        ...mapGetters({
            currentOrderId: 'order/currentOrderId',
            order: 'order/order',
            owner: 'order/owner',
            ownerAddress: 'order/ownerAddress',
            propertyAddress: 'order/propertyAddress',
        }),
        //
        isValid() {
            return !this.$v.$anyError
        },
        countyIsInvalid() {

            return this.address.County == null;
        },
        townIsInvalid() {
            return this.address.SIRUTA == null;
        },
        zipCodeURL() {
            var zipCodeUrl = 'http://www.coduripostale.com/';
            if (this.county) {
                zipCodeUrl += this.county.Name;
            }
            if (this.town) {
                zipCodeUrl += '/' + this.town.Name.replace(' ', '_');
            }
            return encodeURI(zipCodeUrl);
        }
    },

    created() {
        var model = this;

        axios.all([model.loadCounties()])
            .then(axios.spread(function () {
                //
                model.loadAddress();
            }));

        // model.loadTowns() - are also loaded depending on the selected county (check 'loadAddress' and 'county_changed' event handker below)
    },

    methods: {
        ...mapMutations({
            setOwnerAddress: 'order/setOwnerAddress',
            setPropertyAddress: 'order/setPropertyAddress',
        }),
        //
        validate: function () {
            this.$v.$touch();
            this.$nextTick(() => this.findFirstError());

            return this.isValid;
        },
        chkState: function (val) {
            const field = this.getDescendantProp(this.$v, val);

            return !field.$dirty || !field.$invalid
        },
        //
        county_changed(value) {
            console.log('county_changed');
            this.county = value;
            this.address.County = value.Code;

            this.town = null;
            this.address.Town = null;
            this.address.SIRUTA = null;

            // Load towns - are also loaded in loadAddress() (check the 'county_changed' event handker below)
            axios.all([this.loadTowns(value.Code)])
                .then(axios.spread(function () {
                    //
                }));
        },
        town_changed(value) {
            console.log('town_changed');
            this.town = value;
            this.address.Town = value.Name;
            this.address.SIRUTA = value.CodeSiruta;
        },
        //
        loadCounties() { 
            var model = this;

            var countiesPromise = listService.getCounties()
                .then(response => {
                    model.counties = response.data;
                })
                .catch(e => {
                    showErrorNotification(e);
                })

            return countiesPromise;
        },
        loadTowns(countyCode) { 
            var model = this;

            var townsPromise = listService.getTowns(countyCode)
                .then(response => {
                    model.towns = response.data;
                })
                .catch(e => {
                    showErrorNotification(e);
                })

            return townsPromise;
        },
        loadAddress() {
            var model = this;

            model.loading = true;

            if (this.isOwnerAddress) {
                // edit owner address
                this.address = JSON.parse(JSON.stringify(this.ownerAddress));
            }
            else {
                // edit property address
                this.address = JSON.parse(JSON.stringify(this.propertyAddress));
                
            }
           
            // Load towns - are also loaded depending on the selected county (check the 'county_changed' event handker below)
            if (model.address.County) {
                axios.all([model.loadTowns(model.address.County)])
                    .then(axios.spread(function () {
                        //
                        model.county = model.counties.find(item => item.Code == model.address.County);
                        model.town = model.towns.find(item => item.CodeSiruta == model.address.SIRUTA);
                        //
                        model.loading = false;
                    }));
            }
            else {
                this.town = null;
                this.county = null;
            }
        },

        setPersonAddress(address) {
            var model = this;

            model.loading = true;

            model.address = address;
            if (model.address.County) {
                axios.all([model.loadTowns(model.address.County)])
                    .then(axios.spread(function () {
                        //
                        model.county = model.counties.find(item => item.Code == model.address.County);
                        model.town = model.towns.find(item => item.CodeSiruta == model.address.SIRUTA);
                        //
                        model.loading = false;
                    }));
            };
        }
    },

    watch: {
        address: {
            handler: function (val, oldVal) {

                if (val == null)
                    return;

                if (this.isOwnerAddress) {
                    this.setOwnerAddress(val);
                }
                else {
                    this.setPropertyAddress(val);
                }

            },
            deep: true,
        },
        
    },
}
